'use client';

import { useState, useEffect, useRef } from 'react';
import CopyID from './copy-id';

export default function CopyIDContainer({ id }: { id: string }) {
  const [copied, setCopied] = useState(false);
  const [coords, setCoords] = useState<{ x: number; y: number } | null>(null);
  const [tooltipContainer, setTooltipContainer] = useState<HTMLElement | null>(
    null
  );
  const badgeRef = useRef<HTMLSpanElement | null>(null);

  useEffect(() => {
    setTooltipContainer(document.body);
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);

      if (badgeRef.current) {
        const rect = badgeRef.current.getBoundingClientRect();
        setCoords({
          x: rect.left + rect.width / 2,
          y: rect.top + window.scrollY - 10 // Учитываем скролл страницы
        });
      }

      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Ошибка при копировании:', err);
    }
  };

  return (
    <CopyID
      id={id}
      badgeRef={badgeRef}
      onCopy={handleCopy}
      copied={copied}
      coords={coords}
      tooltipContainer={tooltipContainer}
    />
  );
}
